<template>
  <div>
    <toggle-single id="enable-agenda"
                   label-name="Enabled"
                   :toggle-model="hasAgenda"
                   @toggle-click="handleToggleClick"
                   />
    <!--- CERW  -->
    <template v-if="this.form && this.form.crew && Array.isArray(this.form.crew)">
       <crew-member-row
          v-for="(aCrewMember, i) in this.form.crew"
          :crew-member="aCrewMember"
          :key="`crew_${i}`"
        />
    </template>
    <div v-else>
      No Crew
    </div>

    <pre v-if="!production" class="small">{{ context }}</pre>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LabelInfo from "@/components/common/labelInfo";
import ToggleSingle from "@/components/common/toggleSingle";
import CrewMemberRow from "./crewRow"
export default {
  name: "AddEditSession_Crew",
  components: {
    LabelInfo,
    ToggleSingle,
    CrewMemberRow
  },
  props: {
    form: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  beforeMount() {},
  mounted() {},
  computed: {
    ...mapGetters({}),
  },
  methods: {
    handleValueChange(key, value) { //mixin
      this.$emit('value-change', {key:key, value:value});
    },
    handleToggleClick({idx, key}) {

     // this.form.crew[idx].role[key]= !this.form.crew[idx].role[key];
    },
    input(val) {
      this.handleValueChange('agenda', val.content);
    },
    resetClear() {
      this.clear = false;
    },
  },
  data() {
    return {
      production: true,
      clear: false,
      hasAgenda: this.form && this.form.hasAgenda ? this.form.hasAgenda : true,
      agenda: this.form && this.form.agenda ? this.form.agenda : null,
    };
  },
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.session-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#session_calender .btn-outline-info:hover,
#session_calender .btn-outline-info:active,
#session_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>

